/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JourneySegmentBody
 */
export interface JourneySegmentBody {
    /**
     * 
     * @type {string}
     * @memberof JourneySegmentBody
     */
    questConfigId: string;
    /**
     * 
     * @type {number}
     * @memberof JourneySegmentBody
     */
    x?: number;
    /**
     * 
     * @type {number}
     * @memberof JourneySegmentBody
     */
    y?: number;
}

/**
 * Check if a given object implements the JourneySegmentBody interface.
 */
export function instanceOfJourneySegmentBody(value: object): value is JourneySegmentBody {
    if (!('questConfigId' in value) || value['questConfigId'] === undefined) return false;
    return true;
}

export function JourneySegmentBodyFromJSON(json: any): JourneySegmentBody {
    return JourneySegmentBodyFromJSONTyped(json, false);
}

export function JourneySegmentBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneySegmentBody {
    if (json == null) {
        return json;
    }
    return {
        
        'questConfigId': json['questConfigId'],
        'x': json['x'] == null ? undefined : json['x'],
        'y': json['y'] == null ? undefined : json['y'],
    };
}

export function JourneySegmentBodyToJSON(json: any): JourneySegmentBody {
    return JourneySegmentBodyToJSONTyped(json, false);
}

export function JourneySegmentBodyToJSONTyped(value?: JourneySegmentBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questConfigId': value['questConfigId'],
        'x': value['x'],
        'y': value['y'],
    };
}

